import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzPppWoofy } from './pages'

type TIdToPageMapWoofzPppWoofy = Record<PageIdWoofzPppWoofy, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_PPP_WOOFY: TIdToPageMapWoofzPppWoofy = {
  [PageIdWoofzPppWoofy.DOG_AGE_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/DogAgePpp').then(
        (m) => ({
          default: m.DogAgePpp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/DogAgePpp'),
  },
  [PageIdWoofzPppWoofy.DOG_OWNER_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/questions/DogOwnerQuestion'
      ).then((m) => ({
        default: m.DogOwnerQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/DogOwnerQuestion'),
  },
  [PageIdWoofzPppWoofy.TRAINING_COMMANDS_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/questions/BasicTrainingCommands'
      ).then((m) => ({
        default: m.BasicTrainingCommands,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/questions/BasicTrainingCommands'
      ),
  },
  [PageIdWoofzPppWoofy.URGE_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ppp_woofy/pages/urge/UrgePage'),
  },
  [PageIdWoofzPppWoofy.DOG_BREED_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/questions/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/DogBreedQuestion'),
  },
  [PageIdWoofzPppWoofy.FACING_CHALLENGES_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/questions/FacingChallenges'
      ).then((m) => ({
        default: m.FacingChallenges,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/FacingChallenges'),
  },
  [PageIdWoofzPppWoofy.FACING_CHALLENGES_2_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/questions/FacingChallengesVersion2'
      ).then((m) => ({
        default: m.FacingChallengesVersion2,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/questions/FacingChallengesVersion2'
      ),
  },
  [PageIdWoofzPppWoofy.BEHAVIOR_FREQUENCY_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/questions/BehaviorFrequency'
      ).then((m) => ({
        default: m.BehaviorFrequency,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/BehaviorFrequency'),
  },
  [PageIdWoofzPppWoofy.URGE_PROGRAM_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/urge/UrgeProgram').then(
        (m) => ({
          default: m.UrgeProgram,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/urge/UrgeProgram'),
  },
  [PageIdWoofzPppWoofy.BEHAVIOR_FEELINGS_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/questions/BehaviorFeelings'
      ).then((m) => ({
        default: m.BehaviorFeelings,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/BehaviorFeelings'),
  },
  [PageIdWoofzPppWoofy.FIX_BEHAVIOR_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/questions/FixDogBehavior'
      ).then((m) => ({
        default: m.FixDogBehavior,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/FixDogBehavior'),
  },
  [PageIdWoofzPppWoofy.URGE_4_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/urge/UrgePageVariant4'),
  },
  [PageIdWoofzPppWoofy.COMMANDS_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/DogCommands').then(
        (m) => ({
          default: m.DogCommands,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/DogCommands'),
  },
  [PageIdWoofzPppWoofy.PARENT_GOAL_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/GoalQuestion').then(
        (m) => ({
          default: m.GoalQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/GoalQuestion'),
  },
  [PageIdWoofzPppWoofy.TRAINING_PLACE_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/questions/TrainingPlace'
      ).then((m) => ({
        default: m.TrainingPlace,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/TrainingPlace'),
  },
  [PageIdWoofzPppWoofy.TRAINING_FREQUENCY_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/TimeQuestion').then(
        (m) => ({
          default: m.TimeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/questions/TimeQuestion'),
  },
  [PageIdWoofzPppWoofy.URGE_5_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/urge/UrgePageVariant5').then(
        (m) => ({
          default: m.UrgePageVariant5,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/urge/UrgePageVariant5'),
  },
  [PageIdWoofzPppWoofy.PREPARE_FLOW_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/prepare-flow/PrepareFlowPpp'
      ).then((m) => ({
        default: m.PrepareFlowPpp,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/prepare-flow/PrepareFlowPpp'),
  },
  [PageIdWoofzPppWoofy.EMAIL_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/email/EmailPpp').then(
        (m) => ({
          default: m.EmailPpp,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_ppp_woofy/pages/email/EmailPpp'),
  },
  [PageIdWoofzPppWoofy.NEWSLETTER_URGE_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzPppWoofy.LAST_CHANCE_OFFER_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/last-chance-offer/LastChanceOfferPpp'
      ).then((m) => ({
        default: m.LastChanceOfferPpp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/last-chance-offer/LastChanceOfferPpp'
      ),
  },
  [PageIdWoofzPppWoofy.SUBSCRIPTIONS_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/subscriptions/Subscriptions'
      ).then((m) => ({
        default: m.Subscriptions,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzPppWoofy.CHAT_UPSELL_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzPppWoofy.CHAT_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/chat/ChatPage').then((m) => ({
        default: m.ChatPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ppp_woofy/pages/chat/ChatPage'),
  },
  [PageIdWoofzPppWoofy.ACCOUNT_WOOFY_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_woofy/modules/account/AccountWoofy').then(
        (m) => ({
          default: m.AccountWoofy,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/modules/account/AccountWoofy'),
  },
  [PageIdWoofzPppWoofy.DOWNLOAD_WOOFY_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/download-app-woofy/DownloadApp'
      ).then((m) => ({
        default: m.DownloadAppWoofy,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/download-app-woofy/DownloadApp'
      ),
  },
  [PageIdWoofzPppWoofy.DOWNLOAD_WOOFZ_PPP_WOOFY]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_woofy/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_woofy/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzPppWoofy.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
